// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-wrapper {
  height: 1%;
  flex: 1;
  background-color: white;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/slides-editor/editor.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,OAAO;EACP,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".editor-wrapper {\n  height: 1%;\n  flex: 1;\n  background-color: white;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
